import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import ProductCard from '../components/ProguctCard';
import Grid from '@mui/material/Grid';
import { fetchFirstLevelSort, fetchProduct, fetchProductSort, fetchSecondLevelSort } from '../strapi';
import Flight from '@mui/icons-material/Flight';
import Train from '@mui/icons-material/Train';
import LocationOn from '@mui/icons-material/LocationOn';
import Search from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function Catalog({ setProductId, locale }) {
    let search = locale == 'ru' ? 'Поиск' : 'Search';
    let paging = locale == 'ru' ? 'Показать на странице:' : 'Show on page:';
    let all = locale == 'ru' ? 'Все' : 'All';
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [searching, setSearching] = useState('');
    const params = useParams();
    const { sorting, first } = params;
    const [sort, setSort] = useState(first === '0' ? sorting : '');
    const [sortSecond, setSortSecond] = useState(first === '1' ? sorting : '');
    //console.log('sorting=' + sorting);
    //console.log('first=' + first);
    const navigate = useNavigate();
    const resetSort = () => {
        fetchProduct(locale, '', '', page, pageSize, searching)
            .then(data => {
                setProducts(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
        setValue(-1);
        setValueSecond(-1);
        setSort('');
        setSortSecond('');
        setSecondLevel([]);
        navigate(`/catalog`);

    }
    const updateSort = (f, s) => {
        return fetchProduct(locale, f, s, page, pageSize, searching)
            .then(data => {
                setProducts(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
    }

    const [products, setProducts] = useState([]);
    const [firstLevel, setFirstLevel] = useState([]);
    const [secondLevel, setSecondLevel] = useState([]);
    const [value, setValue] = useState(-1);
    // const [value, setValue] = useState(firstLevel?.findIndex(o=> o.documentId === sorting));
    const [valueSecond, setValueSecond] = useState(-1);
    //const [value, setValue] = useState(sort ? firstLevel?.findIndex(o => o.documentId === sort) : -1);
    //const [valueSecond, setValueSecond] = useState(sortSecond ? secondLevel?.findIndex(o => o.documentId === sortSecond) : -1);
    const [count, setCount] = useState(0);

    // Reload values and secondLevel when handler changes (value, valueSecond)
    // Save and restore sort parameters when navigating from other pages

    useEffect(() => {
        // Try to restore sort parameters from URL or localStorage
        fetchFirstLevelSort(locale)
            .then(async (firstLevelData) => {
                setFirstLevel(firstLevelData);

                // Determine initial value and valueSecond from URL params or localStorage
                let initialValue = -1;
                let initialValueSecond = -1;

                // Try to get from URL params
                if (sorting && firstLevelData.length > 0) {
                    // Check if sorting matches a first-level or second-level documentId
                    const firstIdx = firstLevelData.findIndex(f => f.documentId === sorting);
                    if (first === '0' && firstIdx !== -1) {
                        initialValue = firstIdx;
                    } else if (first === '1') {
                        // Find which first-level contains this second-level
                        for (let i = 0; i < firstLevelData.length; i++) {
                            const secondArr = firstLevelData[i].second_level_sorts || [];
                            const secondIdx = secondArr.findIndex(s => s.documentId === sorting);
                            if (secondIdx !== -1) {
                                initialValue = i;
                                initialValueSecond = secondIdx;
                                break;
                            }
                        }
                    }
                } else {
                    // Try to restore from localStorage if available
                    const savedSort = localStorage.getItem('catalogSort');
                    const savedSortSecond = localStorage.getItem('catalogSortSecond');
                    if (savedSort) {
                        const idx = firstLevelData.findIndex(f => f.documentId === savedSort);
                        if (idx !== -1) initialValue = idx;
                        if (savedSortSecond && idx !== -1) {
                            const secondArr = firstLevelData[idx].second_level_sorts || [];
                            const idx2 = secondArr.findIndex(s => s.documentId === savedSortSecond);
                            if (idx2 !== -1) initialValueSecond = idx2;
                        }
                    }
                }

                setValue(initialValue);
                if (initialValue !== -1 && firstLevelData[initialValue]) {
                    const selectedFirst = firstLevelData[initialValue];
                    const secondLevelArr = selectedFirst.second_level_sorts || [];
                    setSecondLevel(secondLevelArr);
                    setValueSecond(initialValueSecond);

                    // Save to localStorage
                    localStorage.setItem('catalogSort', selectedFirst.documentId || '');
                    if (initialValueSecond !== -1 && secondLevelArr[initialValueSecond]) {
                        localStorage.setItem('catalogSortSecond', secondLevelArr[initialValueSecond].documentId || '');
                    } else {
                        localStorage.removeItem('catalogSortSecond');
                    }
                } else {
                    setSecondLevel([]);
                    setValueSecond(-1);
                    localStorage.removeItem('catalogSort');
                    localStorage.removeItem('catalogSortSecond');
                }

                // Always update products after levels are set
                let selectedSort = '';
                let selectedSortSecond = '';
                if (initialValue !== -1 && firstLevelData[initialValue]) {
                    selectedSort = firstLevelData[initialValue].documentId;
                    if (
                        initialValueSecond !== -1 &&
                        firstLevelData[initialValue].second_level_sorts &&
                        firstLevelData[initialValue].second_level_sorts[initialValueSecond]
                    ) {
                        selectedSortSecond = firstLevelData[initialValue].second_level_sorts[initialValueSecond].documentId;
                    }
                }

                let data = await fetchProduct(locale, selectedSort, selectedSortSecond, page, pageSize, searching);
                setProducts(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });

    }, [locale, pageSize, page, sorting, first]);

    const handleChange = async (newValue) => {
        setValue(newValue);
        setValueSecond(-1);
        setSecondLevel(firstLevel[newValue].second_level_sorts);
        setSort(`${firstLevel[newValue].documentId}`);
        setSortSecond('')
        navigate(`/catalog/${firstLevel[newValue].documentId}/${0}`);
        // await updateSort(firstLevel[newValue].documentId);
    };

    const handleChangeSecond = async (newValue) => {
        setValueSecond(newValue);
        setSortSecond(`${secondLevel[newValue].documentId}`);
        navigate(`/catalog/${secondLevel[newValue].documentId}/${1}`);

        // await updateSort(sort, secondLevel[newValue].documentId);
    };

    const changePage = (event, value) => {
        setPage(value);
        fetchProduct(locale, sort, sortSecond, value, pageSize, searching)
            .then(data => {
                setProducts(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
    };
    const updateSearching = (e) => {
        setSearching(e.target.value);
        fetchProduct(locale, sort, sortSecond, page, pageSize, e.target.value)
            .then(data => {
                setProducts(data.data);
                setPageCount(data.meta.pagination.pageCount);
                setCount(data.meta.pagination.total);
            })
            .catch(err => {
            });
    }
    const catalogView = () => {
        if (products.length > 0) {
            return (
                <Grid container sx={{justifyContent: { xs: 'center', md: 'start' } }}>
                    {products.map((item, index) => (<Grid key={index}>
                        <ProductCard
                            id={item?.documentId}
                            title={item?.name}
                            text={item.description_short}
                            img={item.image !== null ? item.image.url : ''}
                            setProductId={setProductId}
                            locale={locale}
                        />
                    </Grid>))}

                </Grid>
            )
        } else {
            return (
                <Typography sx={{ fontSize: 20, fontWeight: 'bold', m: 5 }} component="div">
                    {locale == 'ru' ? 'Ничего не найдено' : 'Nothing found'}
                </Typography>
            )
        }
    }

    // const updateSort = (f) => {
    //     fetchProductSortFirst(locale, f, page, pageSize)
    //         .then(data => {
    //             setProducts(data.data);
    //             setPageCount(data.meta.pagination.pageCount);
    //             console.log('параметры обновлены')
    //         })
    //         .catch(err => {
    //         });
    // }
    // const updateSortSecond = (f, s) => {
    //     fetchProductSort(locale, f, s, page, pageSize)
    //         .then(data => {
    //             setProducts(data.data);
    //             setPageCount(data.meta.pagination.pageCount);
    //             console.log('параметры обновлены')
    //         })
    //         .catch(err => {
    //         });
    // }

    let catalog = [{ icon: <Flight sx={{ color: '#2D5B96', fontSize: 60, transform: 'rotate(90deg)' }} />, id: '1' },
    { icon: <LocationOn sx={{ color: '#2D5B96', fontSize: 60 }} />, id: '2' },
    { icon: <Train sx={{ color: '#2D5B96', fontSize: 60 }} />, id: '3' }
    ]

    return (
            <div >
                <Container  sx={{ mt: { xs: '', md: '40px' }, pt: { xs: '40px', md: '' } }}>
                    
                    <Stack sx={{ width: '100%', alignItems: 'center' }}>
                        <Paper variant='outlined' sx={{ bgcolor: '#ffffff', width: { xs: '300px', md: '400px' }, height: '60px', borderRadius: '70px', p: 1.5, m: 3, borderColor: '' }}>
                            <Stack direction="row" sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <input className='my_input' placeholder={search} onChange={updateSearching} label={search} style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent' }} />
                                <Box sx={{ bgcolor: '#2D5B96', borderRadius: '45px', alignItems: 'center', justifyContent: 'center', p: 2, width: '35px', height: '100%' }}><Search sx={{ color: '#ffffff', fontSize: 30, }}></Search></Box>
                            </Stack>
                        </Paper>
                    </Stack>
                    <Stack direction="row" justifyContent="center" sx={{ width: '100%', marginBottom: 2 }}>
                        <Button onClick={() => resetSort()}>{locale == 'ru' ? 'сбросить' : 'reset'}</Button>
                    </Stack>
                    <Grid container spacing={3} >

                        {firstLevel != null && firstLevel.map((item, index) =>
                            < Grid key={index} size={{ xs: 12, md: 4 }} sx={{ color: value !== index ? '' : 'white', height: '100%' }} className="btn btn-border-reveal">
                                <Box sx={{ borderRadius: '20px', height: '100%', border: value === index ? '' : '#021526 1px solid', p: 3, bgcolor: (value !== index) ? '' : '#2D5B96' }} onClick={() => handleChange(index)}>
                                    <Stack direction='row' alignItems='center'>
                                        <Box sx={{ bgcolor: '#E6F5FC', width: '60px', height: '60px', borderRadius: '45px', alignItems: 'center', p: 2 }}>{catalog[index].icon}</Box>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold', m: 2 }} component="div">
                                            {item.title}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </Grid>
                        )}
                    </Grid>

                    <Grid container spacing={3} sx={{ mt: '10px' }}>
                        {secondLevel != null && secondLevel.map((item, index) =>
                            <Grid key={index} size={{ xs: 12, md: 3 }} >
                                <Paper variant='outlined' sx={{ bgcolor: valueSecond === index ? '#2D5B96' : 'white', color: valueSecond !== index ? '#2D5B96' : 'white' }} onClick={() => handleChangeSecond(index)}>
                                    <Typography sx={{ fontSize: '16px', m: 2 }} component="div">
                                        {item.title}
                                    </Typography>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>

                    
                    {catalogView()}

                    <Stack direction='row' spacing={2} sx={{ mt: 3, mb: 5, justifyContent: 'center', alignItems: 'center' }}>
                        <Select
                            value={pageSize}
                            label={paging}
                            onChange={(event) => setPageSize(event.target.value)}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={count}>{all}</MenuItem>
                        </Select>
                        <Pagination onChange={changePage} count={pageCount} size="large" className='pagination' sx={{ color: "#5281B5", justifyContent: 'center' }} color="primary" />
                    </Stack>

                </Container>
            </div >
    );
}

export default Catalog;
